import { render, staticRenderFns } from "./prospeccaoCard.vue?vue&type=template&id=699e0d95&scoped=true"
import script from "./prospeccaoCard.vue?vue&type=script&lang=js"
export * from "./prospeccaoCard.vue?vue&type=script&lang=js"
import style0 from "./prospeccaoCard.vue?vue&type=style&index=0&id=699e0d95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699e0d95",
  null
  
)

export default component.exports